import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";
import ScheduleList from "components/menu/schedule/list";

const ScheduleListRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={ScheduleList}
                match={props.match}
            />
        </Switch>
    </div>
);

export default connect()(ScheduleListRouter);
